import { createContext } from 'react';

import { TripListItemContextType, TripListItemProviderProps } from './types';

export const TripListItemContext = createContext<TripListItemContextType>({} as TripListItemContextType);
TripListItemContext.displayName = 'TripListItemContext';

export const TripListItemProvider = ({ value, children }: TripListItemProviderProps) => {
  const { trip } = value;

  return (
    <TripListItemContext.Provider
      value={{
        trip,
      }}
    >
      {children}
    </TripListItemContext.Provider>
  );
};
